import $api from "@/frontend/shared/api/axios";

type TPatchOrganizationImageProps = {
  id: number;
  base64Img: string;
};

export async function patchOrganizationImage({ id, base64Img }: TPatchOrganizationImageProps) {
  const response = await $api.patch(`/organizations/${id}/profile-photo`, { base64Img });
  return response.data;
}
